// extracted by mini-css-extract-plugin
export var copy_cta = "blog-module--copy_cta--9473a";
export var credit = "blog-module--credit--d5dcb";
export var cta_btn = "blog-module--cta_btn--a1878";
export var cta_link = "blog-module--cta_link--37b8d";
export var first = "blog-module--first--65a2d";
export var flight_to_el_mirage = "blog-module--flight_to_el_mirage--564ac";
export var fullbleed = "blog-module--fullbleed--6f52b";
export var image_credit = "blog-module--image_credit--3a9cb";
export var nd_ctaLink = "blog-module--nd_cta-link--c43ad";
export var page_story = "blog-module--page_story--73671";
export var qbtn = "blog-module--qbtn--38a67";
export var sec = "blog-module--sec--b0bda";
export var stores_title = "blog-module--stores_title--e2b5b";
export var subtitle = "blog-module--subtitle--0ba74";
export var title = "blog-module--title--7566e";
export var title_image = "blog-module--title_image--67a9b";
export var title_img = "blog-module--title_img--aaf85";
export var title_link = "blog-module--title_link--b303d";
export var use_caslon = "blog-module--use_caslon--028e7";
export var use_mason = "blog-module--use_mason--8dcaf";
export var use_proxw = "blog-module--use_proxw--2e983";
export var video = "blog-module--video--b8ccf";
export var wide_video = "blog-module--wide_video--4ea0c";